import { CalendarPlus, WarningCircle } from '@phosphor-icons/react';

import pt from '../../locales/pt';
import { ANNUAL_OCCASIONAL_SUGGESTIONS } from '../../lib/annualOccasionalSuggestions';

/** `.pen` → `ds/empty-state--occasionals` (master `pbWk2`). Confirmado sem
 * overrides de conteúdo nas instâncias — só padding/width variam por viewport. */
export function AnnualCalendarEmpty({ onAddSuggestion, onAddCustom }) {
  return (
    <div className="flex flex-col items-center gap-space-4 rounded-ds-lg border border-border bg-card p-space-5 md:p-space-6">
      <div className="relative flex h-24 w-24 items-center justify-center">
        <span className="absolute inset-0 rounded-ds-full bg-sage-glow-soft blur-[10px]" aria-hidden />
        <span className="relative flex h-14 w-14 items-center justify-center rounded-ds-full bg-sage-tint">
          <CalendarPlus className="h-6 w-6 text-sage-on-tint" aria-hidden />
        </span>
      </div>

      <h2 className="type-title-card text-center font-bold text-foreground">
        {pt.calendar.emptyState.title}
      </h2>

      <div className="flex w-full items-center gap-space-2 rounded-ds-md bg-warning-tint p-space-3">
        <WarningCircle className="h-4 w-4 shrink-0 text-warning-fg" aria-hidden />
        <p className="type-body-sm font-semibold text-warning-fg">{pt.calendar.emptyState.example}</p>
      </div>

      <p className="type-body-sm text-center text-muted-foreground">
        {pt.calendar.emptyState.solve}
      </p>

      <p className="type-section w-full text-center text-muted-foreground">
        {pt.calendar.emptyState.suggestionsEyebrow}
      </p>

      <ul className="grid w-full grid-cols-2 gap-space-2">
        {ANNUAL_OCCASIONAL_SUGGESTIONS.map((suggestion) => {
          const Icon = suggestion.icon;
          return (
            <li key={suggestion.id}>
              <button
                type="button"
                onClick={() => onAddSuggestion?.(suggestion)}
                aria-label={`${pt.calendar.addInMonth} ${suggestion.name}`}
                className="flex w-full items-center gap-space-2 rounded-ds-full border border-border bg-muted px-space-3 py-space-2 text-left hover:bg-sage-tint"
              >
                <Icon className="h-[15px] w-[15px] shrink-0 text-sage-on-tint" aria-hidden />
                <span className="type-chip min-w-0 truncate font-semibold text-foreground">
                  {suggestion.name}
                </span>
              </button>
            </li>
          );
        })}
      </ul>

      <p className="flex items-center gap-space-1 type-body-sm text-muted-foreground">
        {pt.calendar.emptyState.customPrefix}
        <button
          type="button"
          onClick={onAddCustom}
          className="type-body-sm font-semibold text-sage-on-tint hover:underline"
        >
          {pt.calendar.emptyState.customLink}
        </button>
      </p>
    </div>
  );
}
